/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Title } from './Title';

const BuySellOrderFinalised = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successGreen'} />
      <Title>{t('NOTIFICATION_BUY_SELL_ORDER_FINALISED__title')}</Title>
    </>
  );
};

export { BuySellOrderFinalised };
